import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import * as S from './styled';
const BaseCardBodyWrapper = styled.div`
  ${S.StyledBaseCardBody}
  ${props => S[props.hasBodyBackground]};
  ${props => S[props.titleSizeSm]};
  ${props => S[props.titleSizeMd]};
  ${props => S[props.titleSizeLg]};
  ${props => S[props.wide]};
`;

const BaseCardBody = ({
  children,
  hasBodyBackground,
  titleSizeSm,
  titleSizeMd,
  titleSizeLg,
  wide
}) => /*#__PURE__*/React.createElement(BaseCardBodyWrapper, {
  hasBodyBackground: hasBodyBackground,
  titleSizeSm: titleSizeSm,
  titleSizeMd: titleSizeMd,
  titleSizeLg: titleSizeLg,
  wide: wide
}, /*#__PURE__*/React.createElement("h2", null, children));

BaseCardBody.defaultProps = {
  titleSizeSm: null,
  titleSizeMd: null,
  titleSizeLg: null,
  wide: false
};
BaseCardBody.propTypes = {
  hasBodyBackground: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired,
  titleSizeSm: PropTypes.string,
  titleSizeMd: PropTypes.string,
  titleSizeLg: PropTypes.string,
  wide: PropTypes.bool
};
export default BaseCardBody;